import logger from '@/utils/logger';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, User, Building2, MessageSquare } from 'lucide-react';
import PublicLayout from '../components/layout/PublicLayout';
import { Button } from '../components/ui/button';

export default function Waitlist() {
 const [email, setEmail] = useState('');
 const [fullName, setFullName] = useState('');
 const [companyName, setCompanyName] = useState('');
 const [motivation, setMotivation] = useState('');
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState('');
 const [success, setSuccess] = useState(false);

 const handleSubmit = async (e: React.FormEvent) => {
 e.preventDefault();
 setLoading(true);
 setError('');

 try {
 // Utiliser l'URL backend appropriée selon l'environnement
 const backendUrl = window.location.hostname === 'localhost'
 ? 'http://localhost:3000'
 : 'https://clairifybackendaqetdhg6-container-nostalgic-swanson.functions.fnc.fr-par.scw.cloud';
 
 const response = await fetch(`${backendUrl}/api/waitlist/submit`, {
 method: 'POST',
 headers: {
 'Content-Type': 'application/json',
 },
 body: JSON.stringify({
 email: email.toLowerCase().trim(),
 full_name: fullName.trim(),
 company_name: companyName.trim() || null,
 motivation: motivation.trim() || null,
 }),
 });

 const data = await response.json();

 if (!response.ok) {
 throw new Error(data.error || 'Erreur lors de la soumission');
 }

 setSuccess(true);
 logger.log(' Demande waitlist soumise avec succès');
 } catch (error: any) {
 logger.error(' Erreur soumission waitlist:', error);
 setError(error.message || 'Une erreur est survenue. Veuillez réessayer.');
 } finally {
 setLoading(false);
 }
 };

 if (success) {
 return (
 <PublicLayout>
 <section className="pub-hero">
 <p className="home-kicker">Beta</p>
 <h1>Demande enregistrée.</h1>
 <p>
 Merci. Nous examinons votre demande et vous écrivons très bientôt.
 Invitation avec 500 000 tokens une fois approuvée.
 </p>
 <Link to="/" className="text-[var(--spark-gold)] mt-6 inline-block">← Accueil</Link>
 </section>
 </PublicLayout>
 );
 }

 return (
 <PublicLayout>
 <section className="pub-hero">
 <p className="home-kicker">Beta</p>
 <h1>Rejoindre Clairify.</h1>
 <p>Places limitées. 500 000 tokens offerts. Support prioritaire.</p>
 </section>
 <section className="pub-wrap">
 <div className="grid md:grid-cols-2 gap-12 items-start">
 <div>
 <ul className="home-lines">
 <li><em>01</em> 500 000 tokens pour tout tester.</li>
 <li><em>02</em> Accès anticipé au studio.</li>
 <li><em>03</em> Support direct de l'équipe.</li>
 </ul>
 </div>
 <div className="form-panel">
 <h2>Demandez votre accès</h2>
 <form onSubmit={handleSubmit} className="space-y-4">
 {/* Nom complet */}
 <div>
 <label className="block text-sm font-medium text-theme-primary mb-2">
 <User className="w-4 h-4 inline mr-2" />
 Nom complet *
 </label>
 <input
 type="text"
 value={fullName}
 onChange={(e) => setFullName(e.target.value)}
 className="w-full px-4 py-3 bg-theme-base border border-theme-border rounded-lg text-theme-primary placeholder-theme-tertiary focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-transparent transition-all"
 placeholder="Jean Dupont"
 required
 disabled={loading}
 />
 </div>

 {/* Email */}
 <div>
 <label className="block text-sm font-medium text-theme-primary mb-2">
 <Mail className="w-4 h-4 inline mr-2" />
 Adresse email *
 </label>
 <input
 type="email"
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 className="w-full px-4 py-3 bg-theme-base border border-theme-border rounded-lg text-theme-primary placeholder-theme-tertiary focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-transparent transition-all"
 placeholder="vous@exemple.com"
 required
 disabled={loading}
 />
 </div>

 {/* Entreprise (optionnel) */}
 <div>
 <label className="block text-sm font-medium text-theme-primary mb-2">
 <Building2 className="w-4 h-4 inline mr-2" />
 Entreprise <span className="text-theme-tertiary">(optionnel)</span>
 </label>
 <input
 type="text"
 value={companyName}
 onChange={(e) => setCompanyName(e.target.value)}
 className="w-full px-4 py-3 bg-theme-base border border-theme-border rounded-lg text-theme-primary placeholder-theme-tertiary focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-transparent transition-all"
 placeholder="Votre entreprise"
 disabled={loading}
 />
 </div>

 {/* Motivation (optionnel) */}
 <div>
 <label className="block text-sm font-medium text-theme-primary mb-2">
 <MessageSquare className="w-4 h-4 inline mr-2" />
 Pourquoi souhaitez-vous tester Clairify ? <span className="text-theme-tertiary">(optionnel)</span>
 </label>
 <textarea
 value={motivation}
 onChange={(e) => setMotivation(e.target.value)}
 className="w-full px-4 py-3 bg-theme-base border border-theme-border rounded-lg text-theme-primary placeholder-theme-tertiary focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-transparent transition-all resize-none"
 placeholder="Parlez-nous de votre cas d'usage..."
 rows={3}
 disabled={loading}
 />
 </div>

 {/* Message d'erreur */}
 {error && (
 <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3">
 <p className="text-sm text-red-500">{error}</p>
 </div>
 )}

 {/* Bouton de soumission */}
 <Button type="submit" disabled={loading} className="w-full">
 {loading ? 'Envoi en cours…' : 'Demander mon accès'}
 </Button>
 </form>
 <p className="mt-6 text-sm text-theme-secondary">
 <Link to="/login">Déjà un compte ? Connexion</Link>
 </p>
 </div>
 </div>
 </section>
 </PublicLayout>
 );
}

